export default __webpack_public_path__ + "static/media/googleplay_pl_badge_web.febcad57.png";